import React, { Component } from 'react'
import './style.css'
import Logo from '../../assets/image/onegml.png'
export default class index extends Component {
    render() {
    const {title,subtitle,is_filter}=this.props

        return (
            <div>
                <div className='head-page2'>
                    <h1>{title}</h1>
                    &nbsp;&nbsp;&nbsp;
                    <div className='hidden-in-mobile' style={{width:1,height:50,backgroundColor:'#777777'}}></div>
                    &nbsp;&nbsp;&nbsp;
                    <p className='hidden-in-mobile'>{subtitle}</p>

                </div>
                {/* <br/> */}
                <p className='show-in-mobile'>{subtitle}</p>
                
                {is_filter?
                <>
                <div className='filter'>
                    <h4 style={{color:'#464646'}}>Browse by</h4>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <h4 style={{color:'#00a1ed'}}>All Topic</h4>
                    &nbsp;&nbsp;&nbsp;
                    <div style={{width:1,height:20,backgroundColor:'#464646'}}></div>
                    &nbsp;&nbsp;&nbsp;
                    <h4 style={{color:'#00a1ed'}}>All Date</h4>
                </div>
                </>
                :null}
            </div>
        )
    }
}
